import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=e0549dbc&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=e0549dbc&prod&lang=scss&scoped=true"
import style1 from "./CreateAccount.vue?vue&type=style&index=1&id=e0549dbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0549dbc",
  null
  
)

export default component.exports